<template>
  <div id="after">
    <el-tabs type="border-card" @tab-click="tab">
      <el-tab-pane label="售后申请">
        <div v-if="!is_empty">
          <div v-for="(item,index) of products" :key="index" class="item">
            <div class="lv3Text t">
              <span>下单时间：</span>
              <span>{{dayjs.unix(item.create_time).format('YYYY-MM-DD HH:mm:ss')}}</span>
              <span>单号：</span>
              <span>{{item.orderCode}}</span>
            </div>
            <el-row>
              <el-col :span="3">
                <div>
                  <el-image
                    style="width: 80px; height: 80px;margin:10px"
                    :src="serve + item.images"
                    fit="cover"
                  ></el-image>
                </div>
              </el-col>
              <el-col :span="17">
                <div class="lv2Text t1">{{item.title}}</div>
                <div class="lv3Text" style="font-size:13px">货号：{{item.item_no}} 数量：{{item.number}}</div>
              </el-col>
              <el-col :span="4" style="line-height:100px">
                <el-button type="primary" plain size="mini" @click="apply(item)">申请售后</el-button>
              </el-col>
            </el-row>
          </div>
          <div class="pager" align="center">
            <el-pagination hide-on-single-page background layout="prev, pager, next" :total="total"></el-pagination>
          </div>
        </div>
        <div v-else class="empty lv4Text">
          <img style="margin:0 auto"  :src="serve + '/image/none/order.jpg'" alt="">

        </div>
      </el-tab-pane>
      <el-tab-pane label="申请记录">
        <div v-for="(item,index) of products2" :key="index" class="item">
          <el-row class="t">
            <el-col :span="12">
              <div class="lv3Text">
                <span>申请时间：</span>
                <span>{{dayjs.unix(item.return_date).format('YYYY-MM-DD HH:mm:ss')}}</span>
              </div>
            </el-col>
            <el-col :span="12" align="right">
              <div class="lv0Text">{{item.s}}</div>
            </el-col>
          </el-row>
          <div class="p-item">
            <el-row>
              <el-col :span="3">
                <div>
                  <el-image
                    style="width: 80px; height: 80px;margin-left:10px"
                    :src="serve +item.images"
                    fit="cover"
                  ></el-image>
                </div>
              </el-col>
              <el-col :span="17">
                <div class="lv2Text">{{item.product_title}}1</div>
                <div class="lv3Text" style="font-size:13px">货号：{{item.item_no}} 数量：{{item.number}}</div>
              </el-col>
              <el-col :span="4">
                <div>
                  <el-button size="small" @click="go2(item.return_id)">查看进度</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="pager" align="center">
          <el-pagination hide-on-single-page background layout="prev, pager, next" :total="total"></el-pagination>
        </div>
        <div v-if="products2.length === 0 ">
          <img style="margin:0 auto"  :src="serve + '/image/none/order.jpg'" alt="">
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //
      serve: this.$store.state.serve,
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      page: 1,
      page2: 1,
      products: {},
      products2: [],
      list: [],
      id_arr: [],
      is_empty: true,
      is_empty2: true,
      total: 0,
      total2: 0,
      tabIndex: 1,
      return_id_arr: []
    };
  },
  activated() {
    this.$store.state.user_location = "售后服务";
  },
  created() {
    this.initData();
  },
  methods: {
    go2(id, item) {
      this.$router.push(
        "/user/viewAfter/9?id=" + id 
      );
    },
    tab(e) {
      this.tabIndex = e.index;
      var json = {
        mobile: this.mobile,
        token: this.token
      };
      if (e.index == 1) {
        this.axios
          .get(this.serve + "/personal/return_product_record", {
            params: json
          })
          .then(res => {
            if (res.data.status == "success") {
              this.is_empty2 = false;
              this.products2 = res.data.data.return;
              this.total2 = res.data.data.total;
              for (var item of this.products2) {
                if (item.status == 1) {
                  item.s = "待审核";
                } else if (item.status == 2) {
                  item.s = "已通过";
                } else if (item.status == 3) {
                  item.s = "未通过";
                } else if (item.status == 4) {
                  item.s = "已完成";
                }
              }
            }
          });
      }
    },
    apply(json) {
      this.$router.push({
        path: "/user/afterForm",
        query: { data: JSON.stringify(json) }
      });
    },
    initData() {
      var json = {
        mobile: this.mobile,
        token: this.token,
        page: 1
      };
      this.axios
        .get(this.serve  + "/personal/return_product_list", {
          params: json
        })
        .then(res => {
          if (!_.isEmpty(res.data.results)) {
            this.total = res.data.total;
            this.is_empty = false;
            this.products = res.data.results;
          }
        });
    }
  }
};
</script>
<style lang="scss">
#after {
  .el-tabs__content {
    min-height: 400px;
  }
  .t1 {
    padding: 10px 0;
    margin-top: 20px;
  }
  .cover {
    width: 140px;
    margin: 0 auto;
  }
  .empty {
    text-align: center;
    padding: 30px 0;
  }
  .item {
    border: 1px solid #ddd;
    margin-bottom: 20px;
    .t {
      background-color: #f9f9f9;
      padding: 10px;
      font-size: 12px;
    }
    .p-item {
      line-height: 30px;
      padding: 10px 0;
    }
  }
}
</style>